var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBull1X = function SvgBull1X(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.000000, 12.500000) rotate(180.000000) translate(-12.000000, -12.500000) translate(2.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.78831803,-5.64574007 C5.62186063,-5.44139926 7.31542117,-2.15055322 10.8689996,4.22679805 C7.31542117,10.6052973 5.62128664,13.8961433 5.78659606,14.0993362 C5.89795032,14.238242 8.71056039,10.9466059 14.2244263,4.22442777 C8.76566353,-2.56002493 5.95362745,-5.85008087 5.78831803,-5.64574007 Z",
    transform: "translate(10.000000, 4.224426) rotate(90.000000) translate(-10.000000, -4.224426) "
  }))));
};
export { SvgBull1X as ReactComponent };